import { fork, takeEvery, call, put } from 'redux-saga/effects';
import { fetchFeatureFlags, receiveFeatureFlags, rejectFeatureFlags } from './actions';
import * as wam from '@tcc/wam';
import { initializeLaunchDarkly } from 'util/launchDarkly';
import type { CallReturnType } from '../types/Sagas';
import { fieldViewArchRedirect } from 'util/fieldViewArchRedirect';
import envDetect from '@tcc/env-detect';

const isProduction = envDetect.getCurrentEnv() === envDetect.environments.PRODUCTION;

type fetchFeatureFlagsAction = ReturnType<typeof fetchFeatureFlags>;

export function* fetchFeatureFlagsWorker(action: fetchFeatureFlagsAction) {
  try {
    const { clientId, countryCode } = action.payload || {};

    const userId = clientId || String(wam.getUserId());
    const flags: CallReturnType<typeof initializeLaunchDarkly> 
      = yield call(initializeLaunchDarkly, userId, countryCode);

    if (isProduction) {
      fieldViewArchRedirect(flags);
    }
    return yield put(receiveFeatureFlags(flags));
  } catch (error) {
    return yield put(rejectFeatureFlags());
  }
}

export function* fetchFeatureFlagsWatcher() {
  yield takeEvery(fetchFeatureFlags, fetchFeatureFlagsWorker);
}

export default function* featureFlagsSaga() {
  yield fork(fetchFeatureFlagsWatcher);
}
